import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-204" data-mp="1twgx8w7veibr">
      <div className="mx-auto w-full max-w-3xl" data-id="element-205" data-mp="27mu4ewcxtt01">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-206" data-mp="27nlnj7pcly9f">
          Do You Recognize Yourself in Any of These?
        </h2>

        <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-207" data-mp="2hj6vdmh3lsr3">
          {painPoints.map(point => <li key={point.text} className="flex items-start gap-3 rounded-2xl border border-gold/15 bg-white p-4" data-id="element-208" data-mp="2ckvkd8f2hc7a">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-209" data-mp="2mj1ntugiuqe9">
                {point.emoji}
              </span>
              <span className="text-[14px] leading-snug text-ink-soft" data-id="element-210" data-mp="w86v8h833ukn">{point.text}</span>
            </li>)}
        </ul>

        <SectionCTA headline="You Deserve More Than That" label="YES, I WANT THE SYSTEM" data-id="element-211" data-mp="s7mvr701gevc" />
      </div>
    </section>;
}